<template>
  <div class="ohs-request-display">
    <div class="card card-default mb-4">
      <h4
        class="card-header"
        v-html="title" />
      <div class="card-body">
        <p 
          class="text-danger"
          v-if="!ohsReport.complete">
          <i class="fa fa-exclamation-triangle" /> Report Incomplete
        </p>
        <p class="text-muted" v-if="ohsReport.StaffMember">
          {{ ohsReport.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ ohsReport.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="ohsReport.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: ohsReport.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: ohsReport.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="ohsReport.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: ohsReport.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: ohsReport.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="ohsReport.SentEmails.length">
          <sent-email
            v-for="email in ohsReport.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + ohsReport.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + ohsReport.uuid + '?m=OhsReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !ohsReport.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!ohsReport.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: ohsReport.ReportPdf ? ohsReport.ReportPdf.objectKey : '' }" />
        <button 
          class="my-1 btn btn-primary" 
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button 
          class="my-1 btn btn-info"
          @click="upload()">
          <i class="fa fa-fw fa-upload" /> Upload
        </button>
        <button 
          class="my-1 btn btn-success" 
          @click="send()" 
          :disabled="!ohsReport.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button 
          class="my-1 btn btn-lime" 
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        <router-link 
          :to="'/tax-invoice-requests/new/' + ohsReport.uuid + '?t=OhsReport'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button 
          @click="deleteOhsReport()" 
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    DUPLICATE_OHS_REPORT,
    GENERATE_OHS_PDF,
    SEND_OHS_REPORT,
    UPLOAD_OHS_PDF
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'OhsReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.ohsReport.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.ohsReport.ReportPdf) {
          return this.ohsReport.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.ohsReport.propertyAddress
        }
      },
      generateInvoiceButton () {
        return this.ohsReport.complete && !this.ohsReport.TaxInvoiceRequestUuid
      },
      title () {
        if (this.ohsReport.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.ohsReport.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New Report'
        }
      },
      ohsReport () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deleteOhsReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.ohsReport.uuid,
          reportType: 'OhsReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_OHS_PDF, this.ohsReport)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_OHS_REPORT, this.ohsReport.uuid)
      },
      async upload () {
        await this.$store.dispatch(UPLOAD_OHS_PDF, this.ohsReport.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_OHS_REPORT, this.ohsReport.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/OhsReport.vue